export default __webpack_public_path__ + "static/media/ManageYourPinBackButton.84204454.svg";